<template>
  <v-card class="edit experience elevation-4" dark>
    <can I="edit" a="Experience">
      <v-card-title primary-title v-if="experience.organization">
        <v-avatar v-if="experience.organization.logo" class="mr-3">
          <v-img :src="experience.organization.logo" />
        </v-avatar>
        <div>
          <div class="headline">{{ experience.position }}</div>
          <span class="subheading grey--text">
            {{ experience.organization.name }}
          </span>
        </div>
      </v-card-title>

      <v-alert color="error" transition="scale-transition" :value="experience.errors">
        <ul><li v-for="message in experience.errors" :key="message">{{ message }}</li></ul>
      </v-alert>

      <v-divider />

      <v-form v-model="valid" @submit.prevent="update">
        <v-card-text>
        <v-text-field
          label="Position"
          v-model="experience.position"
          :rules="rules.position" counter="64"
        />

        <v-select
          label="Type"
          v-model="experience.type"
          :items="types"
        />

        <!-- TODO: Experience Organization Select -->
        <v-text-field disabled v-if="experience.organization"
          label="Organization"
          :value="experience.organization.name"
        />

        <DatePicker
          label="Start Date"
          v-model="experience.startsAt"
          required :rules="rules.startsAt"
        />

        <DatePicker
          label="End Date"
          v-model="experience.endsAt"
          clearable
        />

        <v-autocomplete multiple
          label="Disciplines"
          v-model="experience.disciplines"
          :items="disciplines" return-object item-text="name"
        >
          <v-chip slot="selection" slot-scope="{ item: discipline }">
            {{ discipline.name }}
          </v-chip>
        </v-autocomplete>
      </v-card-text>

        <v-divider />

        <v-card-text>
          <h4 class="subheading">Responsibilities</h4>
          <v-text-field
            v-for="(responsibility, i) in experience.responsibilities"
            :key="responsibility"
            :value="experience.responsibilities[i]"
            @blur="v => experience.responsibilities[i] = v.target.value"
          />
        </v-card-text>

        <v-card-actions>
          <v-btn flat @click="experience.responsibilities.push('')">
            <v-icon left>mdi-plus</v-icon> Add responsibility
          </v-btn>
          <v-spacer />
          <v-btn flat color="grey" @click="$emit('cancel')">
            Cancel
          </v-btn>
          <v-btn color="primary" :disabled="!valid" @click="update">
            Update Work Experience
          </v-btn>
        </v-card-actions>
      </v-form>
    </can>
  </v-card>
</template>

<script>
// Components
import DatePicker from '@/components/DatePicker'

// Data
import types from '@/data/experience_types'
import industries from '@/data/industries'

// Helpers
import { mapGetters, mapState } from 'vuex'

// Vue Component
export default {
  components: { DatePicker },
  props: { experience: { type: Object, required: true }},
  created() {
    this.$store.dispatch('disciplines/fetchAll')
  },
  data() {
    return {
      // Data
      industries,
      types,
      // Validations
      valid: true,
      rules: {
        position: [(v) => !!v || 'must be provided', (v) => v.length <= 64 || 'may not exceed 64 characters'],
        startsAt: [(v) => !!v || 'Must be provided']
      },
    }
  },
  computed: mapState('disciplines', { disciplines: 'all' }),
  methods: {
    update() {
      if (this.valid) {
        this.$store
          .dispatch('admin/experiences/update', this.experience)
          .then(() => {
            if (!this.experience.errors) this.$emit('cancel')
          })
      }
    },
  },
}
</script>
